<app-breadcrumb></app-breadcrumb>
         
<div class="row mx-1">
    <div class="col-12">
         <p style="text-align: center;">
              ¿Eres director de Banda Sinfónica?
              <br> <br>
              ¿Entusiasta con ganas de formar tu banda?
              <br> <br>
              ¿Maestro de escuela que te apasiona la música y ver crecer a tus alumnos? 
              <br> <br>
              ¡LLÁMANOS!
              <br> <br>
              – TENEMOS ALGO ESPECIAL PARA TI –
         </p>
         <br>
         <p>
         En CLAVE estamos orgullosos de ser los mejores especialistas en instrumentos de aliento madera y metal. Queremos que tengas lo más adecuado de acuerdo a tu proyecto musical, ya sea amateur o avanzado. Conocemos los pros y los contras de cada marca.
         <br> <br>
         Tenemos planes y precios especiales para instituciones musicales, bandas sinfónicas y escuelas públicas o privadas.
         <br> <br>
         Aparte de contar con las mejores marcas te damos asesoría para sacar el máximo provecho de tu presupuesto.
         <br> <br>
         Si no encuentras la marca que estás buscando en nuestra página, contáctanos. Aunque no está todo publicado, tenemos contacto con más de 20 fabricantes de instrumentos de aliento en diferentes países.
         <br> <br>
         Envíanos cualquier cotización, te prometemos mejorarla.
         </p>
         <!-- <div class="row justify-content-around">
              <div class="col-12">
                    <img class="img-fluid" src="Public/Imgs/Misc/Bandas.jpg"> 
               </div>
         </div> -->
    </div>
</div>

 